module.exports = __webpack_public_path__ + "static/media/kaktus_bottom.2a63eeb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/kaktus/kaktus_bottom.png
// module id = 13219
// module chunks = 0